import { FC } from 'react';
import { FieldMetaState } from 'react-final-form';

type Props = {
  meta: FieldMetaState<any>;
};
const FormError: FC<Props> = ({ meta }) => {
  return (meta.error && meta.touched && <div className='small text-danger'>{meta.error}</div>) || null;
};

export default FormError;
